import { render, staticRenderFns } from "./lawsuit_info.vue?vue&type=template&id=e48a468e&scoped=true"
import script from "./lawsuit_info.vue?vue&type=script&lang=js"
export * from "./lawsuit_info.vue?vue&type=script&lang=js"
import style0 from "./lawsuit_info.vue?vue&type=style&index=0&id=e48a468e&prod&scoped=true&lang=less"
import style1 from "./lawsuit_info.vue?vue&type=style&index=1&id=e48a468e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48a468e",
  null
  
)

export default component.exports